import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API_BASE_URL from "../api";
import "../styles/LatestJobs.css";
import SEO from "../components/SEO";

const LatestJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch jobs data
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/api/latest-jobs`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setJobs(Array.isArray(data) ? data : []);
        setError(null);
      } catch (err) {
        console.error("Error fetching jobs:", err);
        setError(err.message);
        setJobs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  // Loading state
  if (loading) {
    return (
      <div className="page-container">
        <h2 className="page-title">Latest Job Notifications</h2>
        <p className="loading-message">Loading jobs...</p>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="page-container">
        <h2 className="page-title">Latest Job Notifications</h2>
        <p className="error-message">Error: {error}</p>
      </div>
    );
  }

  // Empty state
  if (jobs.length === 0) {
    return (
      <div className="page-container">
        <h2 className="page-title">Latest Job Notifications</h2>
        <p className="no-data">No Jobs Available</p>
      </div>
    );
  }

  // Unified Table View (Same layout for Desktop & Mobile)
  return (

    <><><SEO
      title="Latest Government Jobs 2026"
      description="Latest Central Government and State Government Jobs."
      keywords="latest jobs, government jobs, PSU jobs"
      url="https://sarkaricareerinfo.com/latest-jobs" />
      <div className="desktop-table">
      <div className="page-container">
        <h2 className="page-title">Latest Job Notifications</h2>

        {/* <div className="table-wrapper"> */}
        <table className="jobs-table">
          <thead>
            <tr>
              <th className="col-post-date">Post Date</th>
              <th className="col-job-details">Job Details</th>
              <th className="col-last-date">Last Date</th>
              <th className="col-action">More Details</th>
            </tr>
          </thead>

          <tbody>
            {jobs.map((job) => (
              <tr key={job.slug}>
                {/* Column 1: Post Date */}
                <td data-label="Post Date" className="col-post-date">
                  <span className="date-cell">{job.post_date || "N/A"}</span>
                </td>

                {/* Column 2: Job Details (Title + Organization) */}
                <td data-label="Job Details" className="col-job-details">
                  <div className="job-info">
                    <p className="job-title">{job.post_name || "N/A"}</p>
                    <p className="organization-name">
                      {job.organization_name || "N/A"}
                    </p>
                  </div>
                </td>

                {/* Column 3: Last Date */}
                <td data-label="Last Date" className="col-last-date">
                  <span className="last-date">{job.last_date || "N/A"}</span>
                </td>

                {/* Column 4: Action */}
                {/* <td data-label="Action" className="col-action">
        <Link
          to={`/latest-jobs/${job.id}`}
          state={{ json: job.json_data }}
          className="btn-details"
        >
          View Details
        </Link>
      </td> */}

                <td data-label="Action" className="col-action">
                  <Link
                    to={`/info/job/${job.slug}`}
                    className="btn-details"
                  >
                    View Details
                  </Link>
                </td>

                {/* <td data-label="Action" className="col-action">
        <a
          href={job.notification_link}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-details"
        >
          View Notification
        </a>
      </td> */}
              </tr>
            ))}
          </tbody>
        </table>
        {/* </div> */}
      </div>
      </div>
      </>
      
      <div className="mobile-jobs">
        <h2 className="page-title">Latest Job Notifications</h2>
        {jobs.map((job) => (
          <div className="mobile-job-card" key={job.slug}>

            <div className="mobile-date">
              <div className="label">Post Date</div>
              <div className="value">{job.post_date || "N/A"}</div>
            </div>

            <div className="mobile-details">

              <div className="job-title">
                {job.post_name}
              </div>

              <div className="organization">
                {job.organization_name}
              </div>

              <div className="last-date">
                <strong>Last Date:</strong> {job.last_date || "N/A"}
              </div>

              <Link
                to={`/info/job/${job.slug}`}
                className="btn-details"
              >
                More Details
              </Link>

            </div>

          </div>
        ))}
      </div></>

  );
};

export default LatestJobs;